import React from 'react';

const TerminosYCondiciones = () => {
  return (
    <div className="container login-container slide-down-fade" style={{ maxWidth: "800px", padding: "2rem" }}>
      <h2 className="login-title">Términos y Condiciones de Uso</h2>
      <p><strong>Última actualización:</strong> octubre 2025</p>

      <p>
        El acceso y uso del sitio web <strong>Animales Masquefa</strong> implica la aceptación plena de estos Términos y Condiciones. Si no estás de acuerdo con alguno de los puntos, te recomendamos no utilizar la plataforma.
      </p>

      <h3>1. Identificación del titular</h3>
      <p>
        Titular: <strong>Animales Masquefa</strong><br />
        Correo electrónico: <a href="mailto:animalistesmasquefa@gmail.com">animalistesmasquefa@gmail.com</a><br />
        Finalidad: plataforma informativa y de gestión de adopciones de animales.
      </p>

      <h3>2. Objeto del sitio</h3>
      <p>
        El sitio web ofrece información sobre animales en adopción, noticias y servicios de contacto relacionados con la actividad protectora.
      </p>

      <h3>3. Condiciones de uso</h3>
      <ul>
        <li>El usuario se compromete a utilizar la web de forma lícita, sin realizar actividades fraudulentas o contrarias a la buena fe.</li>
        <li>Queda prohibido el envío de contenido ofensivo, spam o información falsa.</li>
        <li>Los datos introducidos en formularios deben ser veraces y actualizados.</li>
      </ul>

      <h3>4. Propiedad intelectual</h3>
      <p>
        Todos los textos, imágenes, logotipos, diseños y código fuente son propiedad de Animales Masquefa o se utilizan con autorización. Queda prohibida su reproducción total o parcial sin consentimiento expreso.
      </p>

      <h3>5. Exclusión de responsabilidad</h3>
      <p>
        Animales Masquefa no se responsabiliza de los posibles daños derivados del mal uso del sitio web, interrupciones del servicio o enlaces externos de terceros.
      </p>

      <h3>6. Protección de datos personales</h3>
      <p>
        El tratamiento de datos personales se realiza conforme a la <a href="/politica-privacidad">Política de Privacidad</a>, en cumplimiento del RGPD y la LOPDGDD.
      </p>

      <h3>7. Enlaces a terceros</h3>
      <p>
        Este sitio puede contener enlaces a webs externas. No nos hacemos responsables del contenido o las políticas de privacidad de dichas páginas.
      </p>

      <h3>8. Modificación de los términos</h3>
      <p>
        Nos reservamos el derecho a modificar estos Términos y Condiciones en cualquier momento. Los cambios se publicarán en esta misma página.
      </p>

      <h3>9. Legislación aplicable</h3>
      <p>
        Estos Términos se rigen por la legislación española. Cualquier conflicto se resolverá ante los tribunales de Barcelona, salvo disposición legal imperativa en contrario.
      </p>

      <div style={{ marginTop: '2rem' }}>
        <a href="/" className="login-link">← Volver al inicio</a>
      </div>
    </div>
  );
};

export default TerminosYCondiciones;
